export default "__VITE_ASSET__C_mM0yqN__"